import styled from "styled-components";

export const ContentHeader = styled.header`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EBEBEB;
`;

export const Loading = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  background: white;
  padding: 20px;
`;

export const ContentBody = styled.body`
  height: 500px;
`;
